import SectionHeading from "@/pages/home/components/SectionHeading";
import { facilities } from "@/mocks/about";

export default function Facilities() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100/60">
      <div className="max-w-6xl mx-auto flex flex-col gap-12">
        <SectionHeading
          eyebrow="Facilities"
          title="비앙카의 내부 시설"
          description="관리 전후로 편안하게 머무를 수 있도록 세심하게 준비된 공간들입니다."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {facilities.map((facility) => (
            <div
              key={facility.id}
              className="group flex flex-col rounded-2xl overflow-hidden bg-white border border-background-200/70 transition-all hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative w-full h-56 md:h-64 overflow-hidden">
                <img
                  src={facility.image}
                  alt={`비앙카 ${facility.name}`}
                  title={`비앙카 피부관리 - ${facility.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col gap-2 p-6">
                <h3 className="text-lg font-bold text-foreground-900">{facility.name}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{facility.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}